import React from 'react';
import {
  AlertDialog, AlertDialogBody, AlertDialogHeader,
} from '@americanexpress/dls-react';

/**
 * Flexible, reusable modal component.
 *
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Controls modal visibility
 * @param {React.ReactNode} [props.icon] - Optional header icon
 * @param {React.ReactNode} props.title - Modal header title
 * @param {React.ReactNode} props.children - Modal body content
 * @param {React.ReactNode} [props.footer] - Optional footer content (typically buttons)
 */
function CommonAlertDialog({
  isOpen,
  icon,
  title,
  children,
  footer,
}) {
  if (!isOpen) return null;

  return (
    <AlertDialog aria-labelledby="vrp-alert-dialog-title" aria-describedby="vrp-alert-dialog-body">
      <AlertDialogHeader id="vrp-alert-dialog-title" icon={icon}>
        {title}
      </AlertDialogHeader>
      <AlertDialogBody id="vrp-alert-dialog-body">
        {children}
      </AlertDialogBody>
      {footer && <div>{footer}</div>}
    </AlertDialog>
  );
}

export default CommonAlertDialog;
